<div class="status-label">
    <img class="status-label-icon" [src]="icon" [ngClass]="{ 'status-label-icon-disabled': disabled }" [alt]="statusLabel" />
    <div *ngIf="statusTooltip" class="statusTooltip">{{ statusTooltip }}</div>
    <div class="status-label-text" [ngClass]="cssClass">{{ statusLabel | beautifyDisplayString }} {{ statusDescription }}</div>
</div>
